var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleCalleeProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25919_15920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25919_15920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "#E4E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 36.1739C56.7096 36.1739 50.7826 42.1009 50.7826 49.3913C50.7826 56.5426 56.3757 62.3304 63.6661 62.5809C63.8887 62.553 64.1113 62.553 64.2783 62.5809C64.3339 62.5809 64.3617 62.5809 64.4174 62.5809C64.4452 62.5809 64.4452 62.5809 64.473 62.5809C71.5965 62.3304 77.1896 56.5426 77.2174 49.3913C77.2174 42.1009 71.2904 36.1739 64 36.1739Z",
    fill: "#5A7FFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7983 69.3979C70.8471 63.4304 56.2492 63.4304 47.2338 69.3979C43.1592 72.125 40.9133 75.8146 40.9133 79.7608C40.9133 83.7071 43.1592 87.3646 47.2017 90.0596C51.6933 93.0754 57.5967 94.5833 63.5 94.5833C69.4033 94.5833 75.3067 93.0754 79.7983 90.0596C83.8408 87.3325 86.0867 83.675 86.0867 79.6967C86.0546 75.7504 83.8408 72.0929 79.7983 69.3979Z",
    fill: "#5A7FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleCalleeProfile);
export default __webpack_public_path__ + "static/media/sample-callee-profile.facbb825a404fac89814ce3c4a9c73c1.svg";
export { ForwardRef as ReactComponent };